import { createContext, useContext, type ReactNode } from "react";

export type OpenScriptureArgs = {
  reference: string;
};

export type OpenScriptureHandler = (args: OpenScriptureArgs) => void;

const ScriptureActionContext = createContext<OpenScriptureHandler | null>(null);

/**
 * Provider for "open scripture in side-stage" dispatch.
 *
 * ScriptureCard reads this context — when set, the card renders a
 * button that dispatches the handler instead of an anchor that
 * navigates to openbible.com. When unset (admin replay, embedded
 * preview), the card falls back to the external link.
 *
 * Mirrors VideoActionContext so the widget owns side-stage state
 * once and nested cards just dispatch into it.
 */
export function ScriptureActionProvider({
  onOpenScripture,
  children,
}: {
  onOpenScripture: OpenScriptureHandler;
  children: ReactNode;
}) {
  return (
    <ScriptureActionContext.Provider value={onOpenScripture}>
      {children}
    </ScriptureActionContext.Provider>
  );
}

export function useScriptureAction(): OpenScriptureHandler | null {
  return useContext(ScriptureActionContext);
}
